export default "__VITE_ASSET__rnazyqLn__"